import React from "react";
import { Eye, Package, Heart, ShoppingCart } from "lucide-react";

const ProductListing = ({
    products = [],
    title = "Products",
    type = "visited",
}) => {

    const getDateValue = (item) => {
        if (type === "visited") return item?.viewed_at;
        if (type === "wishlist") return item?.created_date;
        if (type === "cart") return item?.created_date;
        return null;
    };

    const getDateLabel = () => {
        if (type === "visited") return "Viewed On";
        if (type === "wishlist") return "Wishlisted On";
        if (type === "cart") return "Added To Cart";
        return "Date";
    };

    const getEmptyIcon = () => {
        switch (type) {
            case "wishlist":
                return <Heart size={60} className="mx-auto text-gray-300" />;
            case "cart":
                return <ShoppingCart size={60} className="mx-auto text-gray-300" />;
            default:
                return <Package size={60} className="mx-auto text-gray-300" />;
        }
    };

    if (!products.length) {
        return (
            <div className="text-center py-16">
                {getEmptyIcon()}

                <h3 className="mt-3 text-lg font-semibold text-gray-600">
                    No {title} Found
                </h3>
            </div>
        );
    }

    const showDateColumn = true;

    return (
        <div className="space-y-4 max-h-[70vh] overflow-y-auto">
            <div className="flex items-center justify-between">
                <h3 className="text-xl font-semibold">
                    {title}
                </h3>

                
            </div>

            {products.map((item, index) => {

                const product = item?.product_detail || item?.product || item;

                return (
                    <div
                        key={product?.id || index}
                        className="bg-white border rounded-xl p-4 flex gap-4 hover:shadow-md transition"
                    >
                        {/* Image */}
                        <div className="w-24 h-24 rounded-lg overflow-hidden border flex-shrink-0 bg-white">
                            <img
                                src={
                                    product?.product_images?.[0]?.variants?.medium ||
                                    product?.product_images?.[0]?.p_image ||
                                    "/placeholder-product.png"
                                }
                                alt={product?.equip_name}
                                className="w-full h-full object-cover"
                            />
                        </div>

                        {/* Details */}
                        <div className="flex-1">
                            <a
                                href={`${process.env.REACT_APP_FRONTEND_URL}/${product?.slug}`}
                                target="_blank"
                                rel="noreferrer"
                                className="font-semibold text-lg text-slate-800 hover:text-teal-600"
                            >
                                {product?.equip_name}
                            </a>

                            <div className="mt-2 grid grid-cols-2 lg:grid-cols-5 gap-3 text-sm">

                                <div>
                                    <p className="text-gray-400">Brand</p>
                                    <p>{product?.brand || "-"}</p>
                                </div>

                                <div>
                                    <p className="text-gray-400">Price</p>
                                    <p>
                                        ₹
                                        {Number(
                                            product?.asking_price || 0
                                        ).toLocaleString("en-IN")}
                                    </p>
                                </div>

                                {showDateColumn && (
                                    <div>
                                        <p className="text-gray-400">
                                            {getDateLabel()}
                                        </p>

                                        <p>
                                            {getDateValue(item)
                                                ? new Date(
                                                    getDateValue(item)
                                                ).toLocaleString("en-IN")
                                                : "-"}
                                        </p>
                                    </div>
                                )}

                            </div>
                        </div>

                        {/* Action */}
                        <div className="flex items-center">
                            <a
                                href={`${process.env.REACT_APP_FRONTEND_URL}/${product?.slug}`}
                                target="_blank"
                                rel="noreferrer"
                                className="inline-flex items-center gap-2 px-4 py-2 rounded-lg bg-teal-600 text-white hover:bg-teal-700"
                            >
                                <Eye size={16} />
                                View
                            </a>
                        </div>
                    </div>
                );
            })}
        </div>
    );

};

export default ProductListing;
